import { format } from 'date-fns';
import { fr, enUS } from 'date-fns/locale';
import { usePage } from '@inertiajs/vue3';
import {computed} from "vue";

export function useDateFormatting() {
    const page = usePage();

    const currentLocale = computed(() => {
        return page.props.locale || 'fr';
    });

    const dateLocales = {
        'fr': fr,
        'en': enUS
    };

    const dateFormats = {
        'fr': {
            long: 'dd LLLL yyyy',
            short: 'dd/MM/yyyy'
        },
        'en': {
            long: 'dd LLLL yyyy',
            short: 'MM/dd/yyyy'
        }
    };

    const formatDate = (date, formatType = 'long') => {
        const locale = dateLocales[currentLocale.value];
        const formatString = dateFormats[currentLocale.value][formatType];

        return format(new Date(date), formatString, { locale });
    };

    return {
        formatDate,
        currentLocale
    };
}
